var _dec, _dec2, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Service, { inject as service } from '@ember/service';
import { DashboardWebAccountService } from '@square/dashboard-protos/models/squareup/bbfrontend/dashboardweb/account/account_service';
import { computed, set } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import rpc from '@banking/api/utils/rpc';
import { v4 as uuid } from 'uuid';
import { CreateAccountRequest, DeactivateAccountRequest, ListAccountsRequest, UpdateAccountRequest } from '@square/dashboard-protos/models/squareup/bbfrontend/dashboardweb/account/account_request_response';
import { AccountType as CommonAccountType } from '@square/dashboard-protos/models/squareup/banking/common';
let BBFrontendV1AccountService = (_dec = computed('capitalEngineContext.headers'), _dec2 = computed('accounts'), (_class = class BBFrontendV1AccountService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _initializerDefineProperty(this, "accounts", _descriptor2, this);
  }
  getAccount(id) {
    return this.accounts.find(account => account.id === id);
  }
  addToAccounts(account) {
    this.accounts = [...this.accounts, account];
  }
  get client() {
    return DashboardWebAccountService.create(rpc((_, derivedUrl) => derivedUrl, new Map(Object.entries(this.capitalEngineContext.headers))));
  }
  get folderBalances() {
    return this.accounts.filter(account => account.type === CommonAccountType.FOLDERS_ACCOUNT);
  }
  async createAccount(args) {
    const {
      account
    } = await this.client.createAccount(CreateAccountRequest.create(args));
    if (!account) {
      throw new Error('failed to create account');
    }
    return account;
  }
  async updateAccount(id, name) {
    const {
      account
    } = await this.client.updateAccount(UpdateAccountRequest.create({
      id,
      name,
      idempotenceKey: uuid()
    }));
    if (!account) {
      throw new Error('failed to update account');
    }
    return account;
  }
  async deactivateAccount(id) {
    const {
      account
    } = await this.client.deactivateAccount(DeactivateAccountRequest.create({
      accountId: id
    }));
    if (!account) {
      throw new Error('failed to delete account');
    }
    return account;
  }
  async listAccounts(owners) {
    if (owners.length === 0) {
      throw new Error('Must provide at least one owner');
    }
    const {
      accounts
    } = await this.client.listAccounts(ListAccountsRequest.create({
      owners
    }));
    set(this, 'accounts', accounts);
    return accounts;
  }
  async retrieveAccount(accountId, owners) {
    // See if we've already fetched this account
    const existingAccount = this.getAccount(accountId);
    if (existingAccount) {
      return existingAccount;
    } else {
      await this.listAccounts(owners);
      const fetchedAccount = this.getAccount(accountId);
      if (fetchedAccount) {
        return fetchedAccount;
      } else {
        throw new Error(`Unable to retrieve account ${accountId}`);
      }
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "accounts", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "client", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "client"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "folderBalances", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "folderBalances"), _class.prototype)), _class));
export { BBFrontendV1AccountService as default };